import React from "react";
function ProjectCard({name, info, link, image}) {
  return (
    <div>
      
        <div class="prj_card">
          <div class="prj_card_top">
            <img src={image} alt='img'></img>
          </div>
          <div class="prj_card_bottom">
            <h4>{name}</h4>
            <p className="prj_info">
            {info}
            </p>
            <a href={link} style={{textDecoration: "none", color: "inherit"}} target="_blank" rel="noreferrer">
            <button class="demo-btn">Live demo</button>
            </a>
            
          </div>
        </div>
      
    </div>
  );
}

export default ProjectCard;
